import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@material-tailwind/react';
import App from './App';
import './index.css';

/**
 * Zest Payment Request Collection - Frontend Entry Point
 * 
 * React application initialization with:
 * - Strict mode for development warnings
 * - Material Tailwind theme provider
 * - Root component rendering
 */

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
